import { Stack, Paper, Text, Group, Title } from '@mantine/core';
import { useAliases } from '../../aliases/hooks/useAliases';
import { useContacts } from '../../contacts/hooks/useContacts';
import { useTags } from '../../tags/hooks/useTags';

export const IndexPage = () => {
    const { items: aliases } = useAliases();
    const { items: contacts } = useContacts();
    const { items: tags } = useTags();

    return (
        <Stack p="xl">
            <Title order={2}>Account Settings</Title>
            
            <Group gap="lg">
                <Paper withBorder p="xl" radius="md" style={{ minWidth: 200 }}>
                    <Stack gap="xs">
                        <Text size="xl" fw={700}>{aliases.length}</Text>
                        <Text c="dimmed">Aliases</Text>
                    </Stack>
                </Paper>

                <Paper withBorder p="xl" radius="md" style={{ minWidth: 200 }}>
                    <Stack gap="xs">
                        <Text size="xl" fw={700}>{tags.length}</Text>
                        <Text c="dimmed">Tags</Text>
                    </Stack>
                </Paper>

                <Paper withBorder p="xl" radius="md" style={{ minWidth: 200 }}>
                    <Stack gap="xs">
                        <Text size="xl" fw={700}>{contacts.length}</Text>
                        <Text c="dimmed">Contacts</Text>
                    </Stack>
                </Paper>
            </Group>
        </Stack>
    );
};
